import React from "react";

/*eslint-disable */
interface ComuniqueseComponentProps {
  assistancesContact: any;
}

declare const window: any;
const ComuniqueseComponent: React.FC<ComuniqueseComponentProps> = ({assistancesContact}) => {
  return (
    <div className="comuniquese-posventa-asistencia-component">
      {/* H2 - Título principal */}
      <h2 className="text1-banner-posventa-asistencia-component">{assistancesContact?.title}</h2>
      
      {/* H3 - Subtítulo "Comunícate:" */}
      <h3 className="text2-banner-posventa-asistencia-component">Comunícate:</h3>
      
      {/* H4 - Teléfonos (son datos importantes, no solo texto) */}
      <h4 className="text3-banner-posventa-asistencia-component">{assistancesContact?.phone1}</h4>
      <h4 className="text4-banner-posventa-asistencia-component">{assistancesContact?.phone2}</h4>
      <h4 className="text4-banner-posventa-asistencia-component">{assistancesContact?.phone3}</h4>
    </div>
  );
};

export default ComuniqueseComponent;